var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "examination-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 44.918,
    viewBox: "0 0 53 44.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M76.782,334.029H63.76v-1.92H56.04a4.038,4.038,0,0,1-2.05-.575v2.5H40.969a2.722,2.722,0,0,0,0,5.388h3.72a2.925,2.925,0,0,0-.09.716,2.238,2.238,0,1,0,4.431,0,2.923,2.923,0,0,0-.09-.716H68.811a2.925,2.925,0,0,0-.09.716,2.238,2.238,0,1,0,4.43,0,2.923,2.923,0,0,0-.09-.716h3.72a2.722,2.722,0,0,0,0-5.388Z",
    transform: "translate(-32.531 -297.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M299.466,252.124a2.413,2.413,0,0,0-2.245-2.551h-.469v5.1h.469A2.413,2.413,0,0,0,299.466,252.124Z",
    transform: "translate(-250.537 -230.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M64.519,180.4l8.042,6.033.054-5.774-4.341-2.322c7.7,1.558,7.2,1.47,7.432,1.47a1.773,1.773,0,0,0,1.353-.657l5.166-6.139a2.335,2.335,0,0,0-.06-3.005,1.718,1.718,0,0,0-2.646.068l-4.472,5.316-6.116-1.237,4.778-.477L70.692,171a2.573,2.573,0,0,0-3.916.551L63.857,175.8A3.445,3.445,0,0,0,64.519,180.4Z",
    transform: "translate(-53.467 -164.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 4.13,
    cy: 4.692,
    rx: 4.13,
    ry: 4.692,
    transform: "translate(2.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M295.389,300.434h-4.84v.959a5.591,5.591,0,0,1-1.164,3.458h6a2.226,2.226,0,0,0,0-4.417Z",
    transform: "translate(-244.334 -272.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M19.221,224.906l.048-5.112L3.013,207.651a1.808,1.808,0,0,0-2.693.632,2.4,2.4,0,0,0,.556,3.059l18.346,13.705C19.222,225,19.22,224.953,19.221,224.906Z",
    transform: "translate(0 -195.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M136.06,204.43l-.112,12a2.831,2.831,0,0,0,.67,1.88,2.189,2.189,0,0,0,1.648.781h18.512a2.49,2.49,0,0,0,2.318-2.633v-10.7a5.444,5.444,0,0,0-3.464-5.264l-10.655-3.572c-.181.241.458-.527-5.308,6.327C139.122,203.9,138.087,205.514,136.06,204.43Z",
    transform: "translate(-114.94 -187.318)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.c4824f33dea1525b8cacd5030af97056.svg";
export { ForwardRef as ReactComponent };